<template>
  <div>
    <q-card class="col-12 marginTag">
      <q-card-section>
        <div class="titleCard">Período aplicable</div>
        <q-form ref='form'>
        <div class="row">
            <q-input
              class="required col-md-auto col-xs-12 col-sm-12"
              outlined
              label="Fecha inicio"
              v-model="dateInicio"
              mask="date"
              :error="$v.dateInicio.$error"
              :rules="[
              'date',
              (val) =>
                  validateFechaIni(dateInicio, dateFin) ||
                  'La fecha inicial no puede ser superior a la fecha final'
                  ]"
              :dense="responsiveSize"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer" >
                  <q-popup-proxy
                    ref="qDateProxy"
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="dateInicio">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Cerrar"
                          color="primary"
                          flat
                        ></q-btn>
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
              <template v-slot:error>Fecha no válida.</template>
            </q-input>

            <q-input
              class="required col-md-auto col-xs-12 col-sm-12"
              outlined
              label="Fecha Fin"
              v-model="dateFin"
              mask="date"
              :error="$v.dateFin.$error"
              :rules="[
              'date',
              (val) =>
                  validateFechaFin(dateInicio, dateFin) ||
                  'La fecha final no puede ser inferior a la fecha inicial'
              ]"
              :dense="responsiveSize"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    ref="qDateProxy"
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date v-model="dateFin">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Cerrar"
                          color="primary"
                          flat
                        ></q-btn>
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
              <template v-slot:error> Fecha no válida.</template>
            </q-input>

            <q-btn
              data-cy="bfilterDataIndicador"
              @click="filterDataIndicadores()"
              unelevated
              class="bPrincipal"
              :disable="buttonDisabled"
              :dense="responsiveSize"
              >FILTRAR</q-btn
            >
        </div>
        </q-form>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import Loading from '@/components/shared/mixins/Loading.js';
import { QPopupProxy, QForm } from 'quasar';
import Validation from '@/components/shared/mixins/Validation.js';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
  components: {
    QPopupProxy,
    QForm
  },
  validations: {
    dateInicio: { required },
    dateFin: { required }
  },
  mixins: [Loading, Validation],
  props: {
    dataIndicador: Object
  },
  data () {
    return {
      dateInicio: null,
      dateFin: null,
      responsiveSize: false
    };
  },
  created () {
    this.fillFechas();
    this.responsiveSize = window.innerWidth <= 640;
  },
  watch: {
    dataIndicador () {
      this.fillFechas();
    }
  },
  computed: {
    buttonDisabled () {
      return !this.dateInicio || !this.dateFin;
    }
  },
  methods: {
    filterDataIndicadores () {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$eventHub.$emit('filterRangeOfDates', this.dateInicio, this.dateFin);
        }
      });
    },
    fillFechas () {
      this.dateInicio = null;
      this.dateFin = null;
      if (this.dataIndicador.hasOwnProperty('fechaInicio') && this.dataIndicador.hasOwnProperty('fechaFin')) {
        let dateInicioSimple = this.dataIndicador.fechaInicio.split('T');
        let dateFinSimple = this.dataIndicador.fechaFin.split('T');
        this.dateInicio = moment(dateInicioSimple[0]).format('YYYY/MM/DD');
        this.dateFin = moment(dateFinSimple[0]).format('YYYY/MM/DD');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.row {
  align-items: center;
}
.marginTag {
  margin-top: 25px;
}
.q-field {
  margin-right: 20px;
  padding: 0px;
}
.titleCard {
  margin: 0 0px 10px 4px;
  font-size: 20px;
  font-family: DINPro;
  font-weight: bold;
  letter-spacing: 0.29px;
  color: #474848;
}

@media (min-width: 0){
  ::v-deep{
    .col {
      -webkit-box-flex: none;
      -ms-flex: none;
      flex: none;
    }
  }
}
@media (max-width: 992px) {
   ::v-deep {
    .q-field{
      margin-bottom: 5px;
      margin-right: 0px;
    }
    .q-field__inner {
      width: 100%;
    }
    .q-field__control-container {
      width: 90%;
    }
   }
}
@media (max-width: 640px) {
  ::v-deep {
    .q-btn {
      margin-left: 0px !important;
    }
    .bPrincipal {
      font-size: 12px;
    }
    .q-field__control-container {
      width: 85%;
    }
  }
}

</style>
